import { doTogglePrintMode } from 'actions/app'
import { doFetchAllChangesetsTicketActions } from './doFetchAllChangesetsTicketActions'

export const doPrintWholeTicket = ticketId => dispatch => {
  dispatch(doFetchAllChangesetsTicketActions(ticketId)).then(() => {
    dispatch(doTogglePrintMode(true))
    setTimeout(() => {
      window.print()
      dispatch(doTogglePrintMode(false))
    }, 500)
  })
}
